<div class="header" *ngIf="hideableColumns.length">
    <div class="header-controls">
        <div class="header-controls-column-selector">
            <div class="header-controls-column-selector-title">
                <ng-content select="wbo-search-grid-header"></ng-content>
            </div>
            <fui-header-form-context>
                <wbo-more-select-control valueField="column" labelField="title"
                                         [data]="hideableColumns"
                                         [value]="enabledColumns"
                                         (valueChange)="enabledColumnsChanged($event)"
                                         [icon]="'add-column'" [iconSize]="26"
                                         [placeholder]="'wbo.search.grid.columns'"></wbo-more-select-control>
            </fui-header-form-context>
        </div>
    </div>
</div>
<div class="table">
    <kendo-grid [data]="model.dataView"
                [sortable]="sortable"
                [sort]="model.dataView?.sort"
                (sortChange)="onSortChange($event)"
                [pageSize]="model.dataView?.limit"
                [skip]="model.dataView?.start"
                [pageable]="model.pageable ? {buttonCount: buttonCount, info: info, type: type, pageSizes: pageSizes, previousNext: previousNext} : false"
                (pageChange)="onPageChange($event)"
                [scrollable]="'none'">
        <kendo-grid-column [width]="20" *ngIf="isSelectMode">
            <ng-template kendoGridHeaderTemplate>
                <fui-inline-action-form-context>
                    <fui-checkbox-control *ngIf="isMultiSelectMode" [value]="allSelected"
                                          (valueChange)="toggleSelectAll($event)"></fui-checkbox-control>
                </fui-inline-action-form-context>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <fui-inline-action-form-context>
                    <div class="selection-controls">
                        <fui-checkbox-control *ngIf="isMultiSelectMode" class="selection-controls-multi"
                                              [value]="isSelected(dataItem)"
                                              (valueChange)="selectRecord($event, dataItem)"></fui-checkbox-control>
                        <fui-mark-button *ngIf="isSelectMode" class="selection-controls-single"
                                         (click)="fireSelectSingleEvent(dataItem)">
                            <fui-icon icon="success" height="10" width="10"></fui-icon>
                        </fui-mark-button>
                    </div>
                </fui-inline-action-form-context>
            </ng-template>
        </kendo-grid-column>
        <ng-container *ngFor="let col of columns">
            <kendo-grid-column
                *ngIf="col.enabled && col.isVisible()"
                [title]="col.title"
                [field]="col.field"
                [style]="{'min-width.px': StringUtils.toString(col.width), 'max-width.px': StringUtils.toString(col.maxWidth)}"
                [class]="{'hideoddstyle': !styleOddRows}"
                [sortable]="col.sortable">
                <ng-template *ngIf="col.contentChildHeaderTemplate" kendoGridHeaderTemplate let-dataItem>
                    <ng-template [ngTemplateOutlet]="col.contentChildHeaderTemplate"
                                 [ngTemplateOutletContext]="{'dataItem': dataItem}"></ng-template>
                </ng-template>
                <ng-template *ngIf="col.viewChildHeaderTemplate" kendoGridHeaderTemplate let-dataItem>
                    <ng-template [ngTemplateOutlet]="col.viewChildHeaderTemplate"
                                 [ngTemplateOutletContext]="{'dataItem': dataItem}"></ng-template>
                </ng-template>
                <ng-template *ngIf="!col.contentChildHeaderTemplate && !col.viewChildHeaderTemplate"
                             kendoGridHeaderTemplate>
                    <div class="column-header" (click)="onHeaderTemplateClick($event)">
                        <div class="column-header-control" *ngIf="col.hideable">
                            <fui-mark-button class="column-header-control-button"
                                             (click)="toggleEnabled(col, $event)">
                                <fui-icon icon="close" height="8" width="8"></fui-icon>
                            </fui-mark-button>
                        </div>
                        <div class="column-header-title" [innerHTML]="col.title | translate"></div>
                    </div>
                </ng-template>
                <ng-template *ngIf="col.contentChildCellTemplate" kendoGridCellTemplate let-dataItem
                             let-rowIndex="rowIndex">
                    <ng-template [ngTemplateOutlet]="col.contentChildCellTemplate"
                                 [ngTemplateOutletContext]="{'dataItem': dataItem, 'rowIndex': rowIndex}"></ng-template>
                </ng-template>
                <ng-template *ngIf="col.viewChildCellTemplate" kendoGridCellTemplate let-dataItem
                             let-rowIndex="rowIndex">
                    <ng-template [ngTemplateOutlet]="col.viewChildCellTemplate"
                                 [ngTemplateOutletContext]="{'dataItem': dataItem, 'rowIndex': rowIndex}"></ng-template>
                </ng-template>
            </kendo-grid-column>
        </ng-container>
        <kendo-grid-column [width]="20" *ngIf="isSelectMode && !disableViewAction && searchPageService.canOpenEntity">
            <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <fui-actions>
                    <wbo-search-action (click)="viewRecord(dataItem)" [icon]="'view-details'"></wbo-search-action>
                </fui-actions>
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
            <fui-empty>
                <fui-icon [height]="64" [icon]="'search-group'" [width]="64"></fui-icon>
            </fui-empty>
        </ng-template>
        <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <div class="pagination">
                <div class="pagination-count" *ngIf="isSelectMode">
                    <kendo-pager-page-sizes [pageSizes]="[25, 50, 100, {  text: 'All', value: 'all'}]"></kendo-pager-page-sizes>
                </div>
                <div class="pagination-count" *ngIf="!isSelectMode">
                    <kendo-pager-page-sizes [pageSizes]="[25, 50, 100]"></kendo-pager-page-sizes>
                </div>
                <div class="pagination-go">
                    <div class="pagination-go-actions">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-next-buttons
                            [ngClass]="{'page-button-disabled': disableNextButton}"></kendo-pager-next-buttons>
                    </div>
                    <div *ngIf="showTotalPages" class="pagination-go-label">
                        <kendo-pager-info></kendo-pager-info>
                    </div>
                </div>
                <div class="pagination-navigation">
                    <kendo-pager-numeric-buttons *ngIf="showTotalPages" [buttonCount]="5"></kendo-pager-numeric-buttons>
                </div>
            </div>
        </ng-template>
    </kendo-grid>
</div>
